<div  class="course"  fxFlex="100" fxFlex.gt-xs="33"
    fxFlex.gt-sm="25"  [@animate]="{value:'*',params:{y:'100%'}}">

<div class="course-content" fxLayout="column" fxFlex="1 1 auto">
    <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
        <button style="background-color: green;color: white;" mat-raised-button><mat-icon aria-hidden="false" aria-label="add icon">add</mat-icon></button>
    </div>
</div>
</div>
